<template>
    <div class="container">
        <div class="word-container">
            <img src="/images/demo-checkout-success.png">
            <div class="success-title hyper3 bold">{{ $t('web.checkout-success.checkout-success') }}</div>
            <div class="original-user" v-if="user">
                <div class="container-1">
                    <div class="space">{{ $t('web.checkout-success.order-number') }}: {{ orderNumber }}</div>
                    <p v-html = "$t('web.checkout-success.sim-product', {sim: productName, email:email})"></p>
                    <div class="hyper6 bold space">{{ $t('web.checkout-success.slogan') }}</div>
                    <div>{{ $t('web.checkout-success.trace-order') }}</div>
                    <div class="container-2">
                        <div class="qr-container">
                            <div class="qr-code">
                                <qr-code
                                        text="https://link.hyperair.com/JR9k6MFkLV"
                                        :size="150"
                                        color="#3155A6"
                                        bg-color="#FFF"
                                        error-level="L">
                                </qr-code>
                            </div>
                        </div>
                        <div class="download-container">
                            <div class="hyper5 bold">{{ $t('web.checkout-success.download-now') }}</div>
                            <div class="search hyper6 navy-blue bold"><i class="far fa-search"></i>{{$t('web.download-app-banner.hyperair')}}</div>
                        </div>
                        <div class="app-container">
                            <a href="https://itunes.apple.com/hk/app/hyperair-%E5%94%B1%E9%8C%A2%E7%A5%9E%E5%99%A8-%E5%A4%96%E5%B9%A3%E9%A0%90%E8%A8%82-%E6%97%85%E9%81%8Asim%E5%8D%A1/id1397364347?mt=8" target="blank">
                                <img class="app-store-image" src="/images/AppStore.svg" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.hyperair.app" target="blank">
                                <img class="play-store-image" src="/images/PlayStore.svg" />
                            </a>
                        </div>
                    </div>
                    <a type="submit" :href="routeContinueShopping" class="continue-shopping-button white hyper8">{{ $t('web.checkout-success.continue-shopping-button' )}}</a>
                </div>
            </div>
        </div>
        <div class="new-user" v-if="needRegister">
            <div class="container-3">
                <form method="post" :action="routeSetPassword">
                    <input type="hidden" :value="token" name="_token" />
                    <input type="hidden" :value="email" name="email" />
                    <input type="hidden" :value="orderNumber" name="orderNumber" />
                    <div>{{ $t('web.checkout-success.order-number') }}: {{ orderNumber }}</div>
                    <p v-html = "$t('web.checkout-success.sim-product', {sim:productName, email:email})"></p>
                    <div class="hyper6 bold space">{{ $t('web.checkout-success.slogan-password') }}</div>
                    <div>{{ $t('web.checkout-success.trace-order-password') }}</div>
                    <div class="container-4">
                        <div class="gray500">{{ $t('web.checkout-success.register-email') }}</div>
                        <div>{{ email }}</div>
                        <div class="field">
                            <label class="label">{{ $t('web.checkout-success.register-password') }}</label>
                            <div class="control">
                                <input class="input" type="password" name="password" placeholder="*********">
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="done-button white hyper8">{{ $t('web.checkout-success.done-button') }}</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: Object,
            productName: String,
            orderNumber: String,
            email: String,
            routeSetPassword: String,
            routeContinueShopping: String,
            needRegister: Boolean
        },

        data(){
            return {
                token: document.head.querySelector('meta[name="csrf-token"]').content,
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/_mixin.scss";
    .container{
        text-align: center;
        img{
            margin-top: 48px;
            margin-bottom: 32px;
            width: 256px;
            height: 250px;
        }
        .success-title{
            margin-bottom: 32px;
        }
        .container-1{
            width: 480px;
            display: inline-block;
            background: white;
            text-align: left;
            padding: 32px 64px;
            margin-bottom: 32px;

            @media (max-width: 768px) {
                width: 90%;
                padding: 24px;
            }

            p{
                margin-bottom: 16px;
            }
            div{
                margin-bottom: 16px;
            }
            .container-2{
                margin-bottom: 0;
            }
            .continue-shopping-button{
                cursor: pointer;
                background: #59D876;
                font-weight: 600 !important;
                margin-top: 16px;
                border-radius: 5px;
                border: none;
                width: 100%;
                display: block;
                padding: 12px;
                text-align: center;
                &:hover{
                    color: white;
                    background: #61CC79;
                }
            }
        }
        .container-2{
            background: #F0F5F9;
            text-align: -webkit-center;
            padding: 24px 0;
            .qr-container{
                padding: 8px;
                width: 120px;
                height: 120px;
                background: #FFF;
                border-radius: 10px;
            }
            .download-container{
                display: flex;
                justify-content: center;
                margin-bottom: 0px;
                @include responsive(){
                    display: block;
                }
                .search{
                    width: 131px;
                    height: 35px;
                    border-radius: 10px;
                    background: #FFFFFF;
                    padding: 4px 0;
                    padding-right: 4px;
                    margin-left: 12px;
                    .far{
                        margin-right:8px;
                    }
                }
            }
            .app-container{
                display: flex;
                justify-content: center;
                margin-bottom: 0;
                img{
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width:90px;
                    height:30px;
                }
                .app-store-image{
                    margin-right: 4px;
                }
            }
        }
        .new-user{
            .container-3{
                width: 480px;
                display: inline-block;
                background: white;
                text-align: left;
                padding: 32px 64px;
                margin-bottom: 32px;
                p{
                    margin-bottom: 16px;
                }
                div{
                    margin-bottom: 16px;
                }

                @media (max-width: 768px) {
                    width: 90%;
                    padding: 24px;
                }
            }
            .container-4{
                background: #F0F5F9;
                text-align: left;
                padding: 16px 32px;
                div{
                    margin-bottom: 0;
                }
                .label{
                    font-weight: initial;
                    margin-top: 24px;
                }
            }
            .done-button{
                background: #59D876;
                border-radius: 5px;
                border: none;
                width: 100%;
                height: 48px;
            }
        }
    }
</style>